import { CreateCommentRequest, GetCommentsResponse } from './Comment.api.type';

/**
 * 댓글 관련 초기화 모음
 */
export const commentInitializer = {
  /**
   * 댓글 작성 요청 파라미터 초기화
   */
  INITIAL_CREATE_COMMENT_PARAM: {
    questionId: '',
    commentContent: '',
    fingerprint: '',
  } as CreateCommentRequest,

  /**
   * 댓글 조회 반환 타입 초기화
   */
  INITIAL_COMMENT_LIST: [
    {
      id: '',
      commentContent: '',
      questionId: '',
      fingerprint: '',
      regDateTime: '',
      authorName: '',
      profileImageUrl: '',
      parentId: '',
      likeCount: 0,
      liked: false,
      replies: [],
    },
  ] as GetCommentsResponse[],
};
